module.exports = __webpack_public_path__ + "static/katikaSEOImage-810abc7c7d8a007e86dbb67afba89ed9.png";